<template>
    <div class="header">
        <div class="toptitle">
            <div class="el-lable title1">您好,欢迎来到<span class="zjrb" target="_blank" @click="handleCommand('Zjrb')">【浙江日报】</span>旗下账号交易中心</div>
            <div class="header-right">
                <div class="header-user-con" v-if="islogon">
                    <div class="el-link" style="margin-left: 5px;margin-right: 5px;" @click="handleCommand('Icon')" v-if="false">ICON</div>
                    <div class="el-link" style="margin-left: 5px;margin-right: 5px;" @click="handleCommand('account')">个人中心</div>
                    <div class="el-lable" style="margin-left: 5px;margin-right: 5px;">|</div>
                    <div class="el-link" style="margin-left: 5px;margin-right: 5px;"  @click="handleCommand('sellerCenter')">卖家中心</div>
                    <div class="el-lable" style="margin-left: 5px;margin-right: 5px;">|</div>
                    <div class="el-link" style="margin-left: 5px;margin-right: 5px;"  @click="handleCommand('buyCenter')">买家中心</div>
                    <div class="el-lable" style="margin-left: 5px;margin-right: 5px;">|</div>
                    <img :src="head" class="shead" />
                    <div class="el-lable">{{ accounts }}</div>
                    <div class="el-lable" style="margin-left: 5px;margin-right: 5px;"></div>
                    <div class="el-link" @click="handleCommand('loginout')">
                        退出
                    </div>
                </div>
                <div class="header-user-con" v-if="!islogon">
                    <!-- 用户名下拉菜单 -->
                    <div class="el-link" style="margin-left: 5px;margin-right: 5px;" @click="handleCommand('logon')">登录
                    </div>
                    <div class="el-lable" style="margin-left: 5px;margin-right: 5px;">|</div>
                    <div class="el-link" style="margin-left: 5px;margin-right: 5px;" @click="handleCommand('regist')">注册
                    </div>

                </div>
            </div>
        </div>
        <div class="el-line-h"></div>
        <div class="headerBottom">

            <img src="../../assets/img/logo.png" class="logo" @click="handleCommand('home')" />
            <div class="serchinput">

                <el-input placeholder="输入关键字搜索" v-model="inputName" class="input-with-select">
                    <el-select v-model="select" slot="prepend" placeholder="选择游戏"
                        style="width: 120px;background-color:#ff8800 ;color: #ffffff;font-size: large;height: 48px;line-height: 48px;">

                        <el-option label="王者荣耀" value="王者荣耀"></el-option>
                        <el-option label="和平精英" value="和平精英"></el-option>
                        <el-option label="原神" value="原神"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search"
                        style="background-color:#ff8800;color: #ffffff;font-size: large;height: 48px;border-radius: 0px;"  @click="serchGame()"></el-button>
                </el-input>
            </div>
        </div>


    </div>
</template>
<script>
import bus from '../common/bus';
import netutil from '../common/netutil.js';
import accounts from '../common/accounts.js';

export default {
    data() {
        return {
            collapse: false,
            select: '王者荣耀',
            inputName: '',
            accounts: '',
            head: '',
            islogon: false
        }
    },
    created() {
        this.baiduAPI();
        this.getGameList(500);
        this.getUserInfo();
    },
    computed: {
    },
    methods: {
        baiduAPI()
        {
            let param={
                site:'https://www.1701gt.com',
                token:'Znoovjw2TMY5Y7oN'
            }
            netutil.post('http://data.zz.baidu.com/urls',param)

          

        },
        getGameList(max) {
            var self = this;
            var param = {               
                max:max
            };
            netutil.get("public/getgamelist", param,
                function (data) {
                   
                    localStorage.setItem('GameList', JSON.stringify(data.data0));
                  
                },
                function (msg) {

                });
        },
        getUserInfo() {
            
            if (accounts.UserID() == 0) return;
            var self = this;
            var param = {};
            netutil.get("user/getuserinfo", param,
                function (data) {
                    localStorage.setItem('UserInfo', JSON.stringify(data.data0[0]));

                    self.accounts = accounts.Accounts();
                    self.head = accounts.HeadImg();
                    self.islogon = (accounts.UserID() != 0);
                },
                function (msg) {
                    self.$message.error(msg);
                });

        },
        serchGame()
        {
            let gid=1;
            let serchGame=this.inputName;
            if(serchGame=='')serchGame=this.select;

            let games = JSON.parse(localStorage.getItem("GameList"));
            for(let i=0;i<games.length;++i)
            {
                if(games[i].GameName.indexOf(serchGame)>=0)gid=games[i].GameID;
            }
           
            let url=`/selectgame?id=${gid}`;
            this.$router.push(url);
        },
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                localStorage.removeItem('UserID');
                localStorage.removeItem('SessionID');
                localStorage.removeItem('UserInfo');

                this.accounts = accounts.Accounts();
                this.head = accounts.HeadImg();
                this.islogon = (accounts.UserID() != 0);
              
                //this.$router.push('/login');
            }
            else if (command == 'logon') {
                localStorage.removeItem('UserID');
                localStorage.removeItem('SessionID');
                localStorage.removeItem('UserInfo');

                this.accounts = accounts.Accounts();
                this.head = accounts.HeadImg();
                this.islogon = (accounts.UserID() != 0);

                this.$router.push('/login?model=logon');
            }
            else if(command=='regist')
            {
                localStorage.removeItem('UserID');
                localStorage.removeItem('SessionID');
                localStorage.removeItem('UserInfo');

                this.accounts = accounts.Accounts();
                this.head = accounts.HeadImg();
                this.islogon = (accounts.UserID() != 0);

                this.$router.push('/login?model=regist');
                
            }
            else if(command=='account')
            {
                this.$router.push('/account?index=1');
                
            }
            else if(command=='Icon')
            {
                this.$router.push('/icon');
            }
            else if(command=='sellerCenter')
            {
                this.$router.push('/account?index=3');
            }
            else if(command=='buyCenter')
            {
                this.$router.push('/account?index=2');
            }
            else if(command=='home')
            {
                this.$router.push('/');
            }
            else if(command=='Zjrb')
            {
                window.open('https://www.zbxinmeiti.com/', '_blank')
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },

    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
}
</script>
<style scoped>
.header {
    width: 100%;
    height: 220px;
    font-size: 20px;
    color: #2e2e2e;
    background-color: #fff;
}


.toptitle {
    height: 40px;
    width: 1200px;
    padding-left: calc(50% - 600px);
    padding-right: calc(50% - 600px);
}

.headerBottom {
    width: 1200px;
    position: absolute;
    padding-left: calc(50% - 600px);
    padding-right: calc(50% - 600px);
}

.logo {
    width: 450px;
    height: 90px;
    float: left;
    left: 0px;
    margin-top: 10px;
    cursor: pointer;
}

.inputserch {
    float: right;
    width: 500px;
    height: 80px;
    margin-top: 10px;
}

.title1 {
    line-height: 40px;
    float: left;
}

.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 40px;
}


.header-right {
    float: right;
}

.header-user-con {
    display: flex;
    height: 40px;
    align-items: center;
}


.user-name {
    margin-left: 10px;
    line-height: 100%;
    font-size: large;
    color: #333333;
}

.user-avator {
    margin-left: 20px;
}

.user-avator img {

    width: 40px;
    height: 40px;
    border-radius: 50%;
    padding-top: 5px;
}


.el-dropdown-menu__item {
    text-align: center;
}


.el-select {
    width: 130px;
    height: 48px;

}

.el-input {
    height: 48px;

}

.input-with-select {
    background-color: #ffffff;
    height: 48px;
    border-radius: 0px;
}

.el-input-group__prepend {
    background-color: #ffffff;
    height: 48px;
}

/deep/ .el-input__inner {

    height: 48px;
    border: 1px solid #ff8800;
    font-size: 18px;
    color: #2e2e2e;

}

.serchinput {
    margin-top: 35px;
    float: right;
    right: 0px;
    width: 500px;
    background-color: #ff8800;
    height: 48px;

}

.el-dropdown-link {
    color: #4b4b4b;
}

.shead {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    border: 1px solid #d3d3d3;
    margin-left: 5px;
    margin-right: 5px;
}

.zjrb{
    color: #ff0000;
    cursor: pointer;
}
</style>
